import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

function App() {
    const [token, setToken] = useState(localStorage.getItem('token') || '');
    const navigate = useNavigate();

    const handleLogin = async (email, senha) => {
        try {
            const res = await axios.post('/auth/login', { email, senha });
            localStorage.setItem('token', res.data.token);
            setToken(res.data.token);
            navigate('/dashboard');   // ✅ redireciona para o dashboard
        } catch (err) {
            // 🔹 em vez de alert, vamos lançar o erro para o Login.js
            throw new Error(err.response?.data?.erro || 'Erro no login');
        }
    };


    return (
        <Routes>
            <Route path="/" element={<Login onLogin={handleLogin} />} />
            <Route path="/dashboard" element={<Dashboard token={token} />} />
        </Routes>
    );
}

// ⚠️ Envolver App em Router para que useNavigate funcione
export default function AppWrapper() {
    return (
        <Router>
            <App />
        </Router>
    );
}
